<template>
  <div class="dvp-modal__top">
    <basic-close-button
      v-if="closeable"
      aria-label="Close Modal"
      :size="closeButtonSize"
      @click="close()"
    />
    <slot />
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue'

  import BasicCloseButton from '@shared/components/Basic/CloseButton'

  // INIT
  const closeable = inject('closeable')
  const close = inject('close')
  const size = inject('size')

  // COMPUTED
  const closeButtonSize = computed(() => {
    return ['maxi', 'full'].includes(size) ? 'lg' : 'sm'
  })
</script>

<style scoped>
.dvp-modal__top {
  display: flex;
  justify-content: flex-end;
  padding: var(--dotcom-responsive-gutter-responsive) var(--dotcom-responsive-gutter-responsive)
    var(--dotcom-responsive-spacing-res-xs);
}
</style>
